import axios from 'axios'

const state = {
  auth: {
    id: null,
    token: null,
    username: null,
    fullname: null,
    permission: {},
    updated_at: null,
    role_id: null
  }
}

const getters = {
  auth: (state) => state.auth
}

const actions = {
  toLogin: async function ({ commit }, user) {
    commit('setLoading', 'memeriksa pengguna')

    let response = null

    try {
      response = await axios.post(`${window.config.BASEURL_API1}/auth/login`, {
        'username': user.username,
        'password': user.password
      })

      if (response) {
        window.localStorage.setItem('token', response.data.token)
      }
    } catch (err) {
      commit('setMessage', {
        text: err.response.data.message,
        status: err.response.status
      })
    }

    commit('unsetLoading')

    return response
  },
  toRecorvery: async function ({ commit }, user) {
    commit('setLoading', 'memeriksa pengguna')

    let response = null

    try {
      response = await axios.post(`${window.config.BASEURL_API1}/auth/recorvery`, {
        'username': user.username
      })

      commit('setMessage', {
        text: response.data.message,
        status: response.status
      })
    } catch (err) {
      commit('setMessage', {
        text: err.response.data.message,
        status: err.response.status
      })
    }

    commit('unsetLoading')

    return response
  },
  toCheckAuth: async function ({ commit }, authType = 'none') {
    const token = window.localStorage.getItem('token')

    if (authType === 'requiredTRUE' && token) {
      const userProfile = await this.dispatch('authenticatedApi', {
        method: 'get',
        url: `${window.config.BASEURL_API1}/profile`
      })

      if (userProfile) {
        userProfile.data.user.token = token

        commit('setAuth', userProfile.data.user)

        return true
      } else {
        return false
      }
    } else if (authType === 'requiredTRUE') {
      return false
    } else if (authType === 'requiredFALSE' && token) {
      return false
    } else if (authType === 'requiredFALSE') {
      return true
    }
  },
  authenticatedApi: async function ({ commit }, api) {
    let response = null

    try {
      const config = {
        headers: {
          'Authorization': window.localStorage.getItem('token')
        }
      };

      if (api.method === 'get') {
        response = await axios[api.method](api.url, config)
      } else if (api.method === 'delete') {
        response = await axios[api.method](api.url, config)
      } else {
        response = await axios[api.method](api.url, api.data, config)
      }

      if (!api.noMessage) {
        commit('setMessage', {
          text: response.data.message,
          status: response.status
        })
      }
    } catch (err) {
      if (err.response) {
        commit('setMessage', {
          text: err.response.data.message,
          status: err.response.status
        })
      } else {
        commit('setMessage', {
          text: err.message,
          status: 500
        })
      }
    }

    return response
  },
  authenticatedUpload: async function ({ commit }, upload) {
    let response = null

    try {
      const config = {
        headers: {
          'Authorization': window.localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data'
        }
      };

      response = await axios.post(upload.url, upload.data, config)

      if (!upload.noMessage) {
        commit('setMessage', {
          text: response.data.message,
          status: response.status
        })
      }
    } catch (err) {
      if (err.response) {
        commit('setMessage', {
          text: err.response.data.message,
          status: err.response.status
        })
      } else {
        commit('setMessage', {
          text: err.message,
          status: 500
        })
      }
    }

    return response
  },
  toLogout: ({ commit }) => {
    window.localStorage.clear()

    // redirect to login page
    window.location.href = `${window.config.BASEURL}/login`
  },
  toChangePassword: async ({ commit, dispatch }, data) => {
    commit('setLoading', 'memperbaharui password')

    await dispatch('authenticatedApi', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/profile/password`,
      data
    })

    commit('unsetLoading')
  }
}

const mutations = {
  setAuth: (state, auth) => {
    state.auth = auth

    let permissionArray = state.auth.permission.split(',')
    let permissionObject = {}

    for (var permissionKey of permissionArray) {
      permissionObject[permissionKey] = true
    }

    state.auth.permission = permissionObject
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
